export function buildCompanyLabel(
  companyName: string,
  sharepoolLabel?: string
): string {
  const company = companyName?.trim().toLowerCase()
  const sharepool = sharepoolLabel?.trim().toLowerCase()

  if (!sharepool || company.includes(sharepool)) return companyName
  if (sharepool.includes(company)) return sharepoolLabel!
  return `${companyName} - ${sharepoolLabel}`
}
